import "./Login.css";
import useLoginPage from "../../hooks/useLoginPage";
import useUserLocation from "../../hooks/useUserLocation";
import LoginHeader from "../../features/Login/LoginHeader/LoginHeader";
import { Button, Modal, Skeleton } from "@mantine/core";
import { IconExclamationCircle } from "@tabler/icons-react";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { openUrl } from "../../utils/OpenUrl";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import LoginDecorativeCircles from "../../features/Login/LoginDecorativeCircles/LoginDecorativeCircles";
import DownloadAPKBanner from "../../components/DownloadAPKBanner/DownloadAPKBanner";
import LoginStaffSkeleton from "../../features/Login/LoginStaffSkeleton/LoginStaffSkeleton";

const MAP_STAFF_TYPE = {
   teacher: "Profesor",
   staff: "Staff",
   director: "Director",
};


export default function Login() {
   const {
      state,
      staff,
      avals,
      isNotBrowserRecommended,
      browserName,
   } = useLoginPage();


   const location = useLocation();
   const message =
      location.search && new URLSearchParams(location.search).get("message");
   const [opened, setOpened] = useState(message != null);

   const close = () => setOpened(false);

   const handleNavigate = () => {
      openUrl("https://forvet.org/contacto");
   };


   // Split staff into two rows for dual marquee
   const staffRow1 = staff ? staff.filter((_, i) => i % 2 === 0) : [];
   const staffRow2 = staff ? staff.filter((_, i) => i % 2 !== 0) : [];

   const splideStaffOptions = (speed) => ({
      type: "loop",
      drag: "free",
      focus: "center",
      autoWidth: true,
      gap: 12,
      arrows: false,
      pagination: false,
      autoScroll: { speed },
   });

   return (
      <main className="LoginPage-container">
         <div className="LoginPage--component">
            <LoginDecorativeCircles />

            <div className="LoginPage-wrapper">
               <LoginHeader />

                 <section className="LoginPage-hero-container">
                  <div className="LoginPage-hero-wrapper">
                     <div className="LoginPage-hero-content">

                        <h1 className="LoginPage-hero-title">
                          La comunidad de <strong>veterinarios</strong> que eleva  el <strong>criterio clínico</strong> en toda <strong>Latinoamérica</strong>.
                        </h1>

                        <p className="LoginPage-hero-slogan">
                          Aprender medicina clínica es importante. <br/>Discutirla con colegas cambia tu práctica.
                        </p>
                     </div>

                  </div>
               </section>

               {isNotBrowserRecommended && (
                  <section className="LoginPage-browser-warning-container">
                     <IconExclamationCircle size={40} color="#2C4B58" />
                     <p className="LoginPage-browser-warning--text">
                        Estas usando el navegador{" "}
                        <strong>{isNotBrowserRecommended}</strong>
                     </p>
                     <p className="LoginPage-browser-warning--text">
                        Para una mejor experiencia te recomendamos que utilices{" "}
                        <strong>Chrome</strong> o <strong>Edge</strong> o puedes
                        habilitar las <strong>cookies de terceros</strong>
                     </p>
                  </section>
               )}
            </div>

            <footer className="LoginPage-footer">
               {/* Staff section - dual marquee */}
               <div className="LoginPage-section">

                  {state.isLoading && <LoginStaffSkeleton />}

                  {!state.isLoading && staff && staff.length > 0 && (
                     <div className="LoginPage-staff__marquee">
                        <Splide
                           options={splideStaffOptions(0.6)}
                           extensions={{ AutoScroll }}
                        >
                           {staffRow1.map((person, idx) => {
                              const onClick = () => {
                                 if (!person.slugName) return
                                 window.open(`https://forvet.org/profesores/${person.slugName}`, '_blank')
                              }
                              return <SplideSlide key={`r1-${person?._id || idx}`} style={{ cursor: person?.slugName ? "pointer" : "unset" }} onClick={onClick}>
                                 <div className="LoginPage-staff__pill">
                                    <img
                                       className="LoginPage-staff__pill-image"
                                       src={person?.profilePicture}
                                       alt={`${person?.name} ${person?.lastname}`}
                                    />
                                    <div className="LoginPage-staff__pill-info">
                                       <span className="LoginPage-staff__pill-name">
                                          {person?.name} {person?.lastname}
                                       </span>
                                       <span className="LoginPage-staff__pill-type">
                                          {MAP_STAFF_TYPE[person?.type]}
                                       </span>
                                    </div>
                                 </div>
                              </SplideSlide>
                           })}
                        </Splide>
                        <Splide
                           options={splideStaffOptions(-0.6)}
                           extensions={{ AutoScroll }}
                        >
                           {staffRow2.map((person, idx) => {
                              const onClick = () => {
                                 if (!person.slugName) return
                                 window.open(`https://forvet.org/profesores/${person.slugName}`, '_blank')
                              }
                              return <SplideSlide key={`r2-${person?._id || idx}`} style={{ cursor: person?.slugName ? "pointer" : "unset" }} onClick={onClick}>
                                 <div className="LoginPage-staff__pill" >
                                    <img
                                       className="LoginPage-staff__pill-image"
                                       src={person?.profilePicture}
                                       alt={`${person?.name} ${person?.lastname}`}
                                    />
                                    <div className="LoginPage-staff__pill-info">
                                       <span className="LoginPage-staff__pill-name">
                                          {person?.name} {person?.lastname}
                                       </span>
                                       <span className="LoginPage-staff__pill-type">
                                          {MAP_STAFF_TYPE[person?.type]}
                                       </span>
                                    </div>
                                 </div>
                              </SplideSlide>
                           })}
                        </Splide>
                     </div>
                  )}
               </div>

             

               {/* Avals section */}
               {avals.length > 0 && (
                  <div className="LoginPage-section">
                     <h3 className="LoginPage-section__title">Nos avalan</h3>
                     {/* Desktop: grid */}
                     <div className="LoginPage-avals__grid LoginPage-avals--desktop">
                        {avals.map((aval) => (
                           <a
                              key={aval?._id}
                              href={aval?.web}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="LoginPage-avals__card"
                           >
                              <img
                                 src={aval?.image}
                                 alt={aval?.name}
                                 className="LoginPage-avals__card-image"
                              />
                              <span className="LoginPage-avals__card-name">
                                 {aval?.name}
                              </span>
                           </a>
                        ))}
                     </div>
                     {/* Mobile: slider */}
                     <div className="LoginPage-avals--mobile">
                        <Splide
                           options={{
                              type: "loop",
                              drag: "free",
                              autoWidth: true,
                              gap: 12,
                              arrows: false,
                              pagination: false,
                              autoScroll: { speed: 0.4 },
                           }}
                           extensions={{ AutoScroll }}
                        >
                           {avals.map((aval) => (
                              <SplideSlide key={`aval-m-${aval?._id}`}>
                                 <a
                                    href={aval?.web}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="LoginPage-avals__card"
                                 >
                                    <img
                                       src={aval?.image}
                                       alt={aval?.name}
                                       className="LoginPage-avals__card-image"
                                    />
                                    <span className="LoginPage-avals__card-name">
                                       {aval?.name}
                                    </span>
                                 </a>
                              </SplideSlide>
                           ))}
                        </Splide>
                     </div>
                  </div>
               )}

               {/* Download banner */}
               {browserName.toLowerCase() !== "safari" && (
                  <div className="LoginPage-footer__bottom">
                     <DownloadAPKBanner my=".5rem" />
                  </div>
               )}
            </footer>
         </div>

         {message && (
            <Modal
               classNames={{
                  title: "loginPage-modal-titleHeader",
                  body: "loginPage-modal-body",
                  header: "loginPage-modal-headerStyling",
               }}
               opened={opened}
               onClose={close}
               title="Hay irregularidades en tu cuenta"
            >
               <div className="loginPage-modal-layout">
                  <img
                     alt="perro"
                     className="loginPage-modal-img"
                     src="https://ugokawaii.com/wp-content/uploads/2022/06/dog-distress.gif"
                  />
                  {message}
                  <Button onClick={handleNavigate} fw="normal">
                     Contáctanos
                  </Button>
               </div>
            </Modal>
         )}
      </main>
   );
}
